import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";

export const SecurityStrategy = () => {
  const { t } = useTranslation();
  return (
    <section>
      <div className="security-strategy">
        <div className="inner">
          <div className="content">
            <div className="title">{t("security.安全防护策略")}</div>
            <div className="subtitle">
              <i className="icon authing-icon authing-yinhao quote-icon"></i>
              <span>{t("security.0")}</span>
              <span className="quote-icon-rotate">
                <i className="icon authing-icon authing-yinhao quote-icon"></i>
              </span>
            </div>
          </div>

          <div className="block-solution">
            <div className="headline">{t("security.Authing解决方案")}</div>
            <div className="card-warp">
              <div className="card">
                <div className="icon">
                  <img
                    src={
                      "//files.authing.co/authing-website/security-icon-audit.svg"
                    }
                    alt="authing solution audit"
                  />
                </div>
                <div className="title">{t("security.可视化安全审计")}</div>
                <div className="item">{t("security.1")}</div>
                <div className="item">{t("security.2")}</div>
                <div className="item">{t("security.3")}</div>
              </div>
              <div className="card">
                <div className="icon">
                  <img
                    src={
                      "//files.authing.co/authing-website/security-icon-multiple.svg"
                    }
                    alt="authing solution mfa"
                  />
                </div>
                <div className="title">{t("security.多因素登录")}</div>
                <div className="item">{t("security.4")}</div>
                <div className="item">{t("security.5")}</div>
              </div>

              <div className="card">
                <div className="icon">
                  <img
                    src={
                      "//files.authing.co/authing-website/security-icon-pass.svg"
                    }
                    alt="authing solution password"
                  />
                </div>
                <div className="title">{t("security.密码管理")}</div>
                <div className="item">{t("security.6")}</div>
                <div className="item">{t("security.7")}</div>
              </div>
            </div>
            <div className="pass-block">
              <div className="block-left">
                <div className="title">{t("security.加密传输与存储")}</div>
                <div className="items">
                  <p>{t("security.security-strategy-item-1")}</p>
                  <p>{t("security.security-strategy-item-2")}</p>
                  <p>{t("security.security-strategy-item-3")}</p>
                  <p>{t("security.security-strategy-item-4")}</p>
                  <p>{t("security.security-strategy-item-5")}</p>
                  <p>{t("security.security-strategy-item-6")}</p>
                  <p>{t("security.security-strategy-item-7")}</p>
                  <p>{t("security.security-strategy-item-8")}</p>
                  <p>{t("security.security-strategy-item-9")}</p>
                </div>
              </div>
              <div className="block-right">
                <img
                  src={
                    "//files.authing.co/authing-website/security-encryption.svg"
                  }
                  alt="身份安全的合规性"
                />
              </div>
            </div>
          </div>

          <div className="security-tip">
            <div>
              <div className="title">{t("security.全生命周期安全保护")}</div>
              <div className="description">{t("security.15")}</div>
            </div>
            <div>
              <img
                src={"//files.authing.co/authing-website/security-bg-icon.svg"}
                alt="authing circyle"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
